import {
  CanvasActionTypes,
  createAutoCreatedBlock,
  selectToEditBlock,
} from '@storeOld/reducers/canvas/canvas'
import { openBlock } from '@storeOld/reducers/ui'
import type { MouseEvent } from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

const useBlockActions = () => {
  const dispatch = useDispatch()

  // @TODO refactor - add type
  const onBlockNoteClick = (payload: any) => {
    dispatch(openBlock(payload))
  }

  // @TODO refactor - add types
  const onBlockSelectClick = (e: MouseEvent, id: string) => {
    e.preventDefault()

    if (e.shiftKey) {
      dispatch({
        type: CanvasActionTypes.ADD_SELECTED_BLOCKS,
        payload: id,
      })
    } else {
      dispatch({
        type: CanvasActionTypes.SELECT_BLOCK,
        payload: id,
      })
    }
  }

  const onBlockEditClick = (blockId: string) => {
    // @todo move action
    // @ts-expect-error
    dispatch(selectToEditBlock(blockId))
  }

  // @TODO refactor - add types
  // @ts-expect-error
  const onBlockInputKeyDown = (e, id, nodeId) => {
    const { which, target, shiftKey } = e

    if ([13, 9].includes(which)) {
      if (shiftKey && which === 13) {
        return
      }

      e.preventDefault()

      if (which === 13 && target.value.length > 0) {
        sendGtmEvent(GtmTriggerName.BLOCK_ADD)

        // @todo move action
        // @ts-expect-error
        dispatch(createAutoCreatedBlock(nodeId, id))
      }
    }
  }

  return {
    onBlockNoteClick,
    onBlockSelectClick,
    onBlockEditClick,
    onBlockInputKeyDown,
  }
}

export default useBlockActions
